import type { ProposalDeliveryRepository } from '../../application/ProposalDeliveryRepository'

/**
 * Mode démonstration : aucun module SMS n'existe, rien n'est envoyé. Les numéros ne sont jamais présentés comme
 * vérifiés.
 */
export function createFixtureProposalDeliveryRepository(): ProposalDeliveryRepository {
  return {
    smsOptions: () => Promise.resolve({ eligible: false, phones: [] }),
    sendSms: () => Promise.resolve({ state: 'REJECTED', reason: 'MODULE_DISABLED', replayed: false }),
    channels: () =>
      Promise.resolve({
        email: null,
        sms: null,
        shortLink: null,
        firstViewedAt: null,
        lastViewedAt: null,
        viewCount: 0,
      }),
    clientPhoneLookups: () => Promise.resolve({ phone: null, mobilePhone: null }),
    retryPhoneLookup: () => Promise.resolve(null),
  }
}
